import { unauthenticatedPost } from '../../../api/request';

export const updatePassword = (data, onFail) => {
    console.log("data", data);
    return unauthenticatedPost(`/web-admin-data/execute-password-reset`, data, onFail);
};
